
import $ from "jquery"
import "chosen-jquery"
import "./html5_error_workaround"
import "./custom_placeholder"
import { Page, Device } from "app/multi_device"


import I18n from "plugins/i18n-js"


// usually `.js-chosen`
const init = (el: string | Element | JQuery, extra_chosen_options: Chosen.Options = {}) => {
  // NEVER use Chosen on mobile phone or when testing with mobile page
  if (Page.isForMobile() || Device.isForMobile()){
    return
  }

  const $el = $(el)
  const final_chosen_options = Object.assign(
    {
      allow_single_deselect:    true,
      no_results_text:          I18n.t("js.jquery_chosen.labels.default_no_result_text"),
      search_contains:          true,
      display_disabled_options: false,
    },
    extra_chosen_options,
  )

  $el.chosen(final_chosen_options)

  // Make the placeholders ourselves, as the original library's
  // `placeholder_text_multiple' option not `data-placeholder'
  // working.
  //
  // Was using `dataset`
  // But some browser does NOT support it
  // Hence using jQuery
  const placeholder_from_data = $el.data("placeholder")
  if ( placeholder_from_data != null ) {
    const chosen_object = $el.data("chosen")
    if ( chosen_object  != null ) {
      chosen_object.search_field.attr("placeholder", placeholder_from_data )
    }
  }
}

export default init


